import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetCpgCampaignQuery } from '../api/api';
import { GetCampaignParams, useCampaignParameters } from '@features/campaigns';

export const useCampaign = (overrideParams?: GetCampaignParams) => {
  const campaignParams = {
    ...useCampaignParameters(overrideParams?.id),
    ...overrideParams,
  };
  const { data, isFetching, error } = useGetCpgCampaignQuery(
    campaignParams.id ? campaignParams : skipToken
  );
  return useMemo(
    () => ({
      campaign: data,
      isFetching,
      error,
    }),
    [data, isFetching, error]
  );
};

export const useCurrentCampaign = () => {
  const { id: campaignId } = useParams<{ id: string }>();
  if (!campaignId) {
    throw new Error('No campaign ID found for current page');
  }

  return useCampaign({ id: Number(campaignId) });
};
